import Text from 'components/Text/Text';
import React, { useState } from 'react';
import CronGeneratorState from './cronGeneratorState/CronGeneratorState';
import Generator from './components/CronGenerator/Generator';
import classNames from 'classnames';
import style from './CronGenerator.module.scss';

const CronGenerator: React.FC = () => {
	const [collapsed, setCollapsed] = useState(true);

	const generatorClass = classNames(style.generator, { [style.generatorCollapsed]: collapsed });

	const toggleCollapsed = () => {
		setCollapsed((prevState) => !prevState);
	};

	return (
		<CronGeneratorState>
			<div className={style.container} data-test="CronGenerator">
				<Text
					className={style.heading}
					translationNameSpace="form"
					translationKey="useGeneratorToCreateScheduleLabel"
					components={[<span key="1" className={style.link} onClick={toggleCollapsed} />]}
					size="l"
					weight="bold"
				/>
				<div className={generatorClass}>
					<Generator />
				</div>
			</div>
		</CronGeneratorState>
	);
};

export default React.memo(CronGenerator);
